<template>
  <div ref="editable" class='vue-xeditable'>  
    <el-tooltip :disabled="!customDisplay" :content="$_VueXeditable_getHTMLValue()">    
     <textarea readonly class="vue-xeditable-value vue-xeditable-value__fix"
      :class="{'vue-xeditable-empty': $_VueXeditable_isValueEmpty}"
      v-if='!enableEdit && fixLabel'
      v-html='customDisplay || $_VueXeditable_getHTMLValue()'>
    </textarea> 
    </el-tooltip>

    <textarea
      readonly
      v-if="enableEdit && fixLabel"
      class="vue-xeditable-value vue-xeditable-value__fix"
      :class="{'vue-xeditable-empty': $_VueXeditable_isValueEmpty}"
      v-show='!isEditing'
      v-on:click='$_VueXeditable_maybeStartEditing(1, $event)'
      v-on:dblclick='$_VueXeditable_maybeStartEditing(2, $event)'
      v-touch-event-handle:doubletap='($event) => $_VueXeditable_maybeStartEditing(2, $event)'
      v-html='$_VueXeditable_getHTMLValue()'>
    </textarea>

    <span class="vue-xeditable-value"
      :class="{'vue-xeditable-empty': $_VueXeditable_isValueEmpty}"
      v-if='!enableEdit && !fixLabel'
      v-html='$_VueXeditable_getHTMLValue()'>
    </span>

    <span
      v-if="enableEdit && !fixLabel"
      class="vue-xeditable-value"
      :class="{'vue-xeditable-empty': $_VueXeditable_isValueEmpty}"
      v-show='!isEditing'
      v-on:click='$_VueXeditable_maybeStartEditing(1, $event)'
      v-on:dblclick='$_VueXeditable_maybeStartEditing(2, $event)'
      v-touch-event-handle:doubletap='($event) => $_VueXeditable_maybeStartEditing(2, $event)'      
      v-html='$_VueXeditable_getHTMLValue()'>
    </span>

    <div v-show='enableEdit && isEditing' class='vue-xeditable-control el-input el-input--mini'>
      <input
        v-if='type === "text"'
        class='el-input__inner'
        type="text"
        :value="rawValue"
        @keydown='$_VueXeditable_onKeydown'
        @blur="$_VueXeditable_stopEditing"
        autofocus
      >

      <textarea
        :value="rawValue"
        v-else-if='type === "textarea"'
        class='el-input__inner'
        @keydown='$_VueXeditable_onKeydown'
        @blur="$_VueXeditable_stopEditing"
      ></textarea>

      <input
        v-else-if='type === "number"'
        class='el-input__inner'
        type="number"
        :value="rawValue"
        @keydown='$_VueXeditable_onKeydown'
        @blur="$_VueXeditable_stopEditing"
      >

      <input
        v-else-if='type === "currency"'
        class='el-input__inner'
        type="number"
        :value="rawValue"
        @keydown='$_VueXeditable_onKeydown'
        @blur="$_VueXeditable_stopEditing"
      >

      <slot v-else-if='type === "custom"' :onChange="onChange"></slot>
    </div> 
    <div v-show="enableEdit && !isEditing && showEditIcon"
      class="vue-xeditable-after"
      v-on:click='$_VueXeditable_maybeStartEditing(1, $event)'
      v-on:dblclick='$_VueXeditable_maybeStartEditing(2, $event)'
      v-touch-event-handle:tap='($event) => $_VueXeditable_maybeStartEditing(2, $event)'>      
      <i class="ico_edit"></i>
    </div>
  </div>
</template>

<script>
import TouchDirective from '../../utils/directives/touch-directive';
export default {
  name: "vue-xeditable",
  directives:{
    'touch-event-handle': TouchDirective
  },
  props: {
    customDisplay: {
      type: String
    },
    customDisplayItem: {
      type: Object
    },
    customDisplayProp: {
      type: String
    },
    value: {
      type: [String, Number, Array]
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    name: {
      type: String,
      required: false,
      default: "VueXeditableDefaultName"
    },
    empty: {
      type: String,
      required: false,
      default: "&nbsp;"
    },
    placeholder: {
      type: String,
      required: false,
      default: ""
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    editOnDoubleClick: {
      type: Boolean,
      required: false,
      default: false
    },
    showEditIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    enableEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    fixLabel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isEditing: false,
      rawValue: this.value,
      langCode: '',
    };
  },
  watch: {
    value(newValue) {
      this.rawValue = newValue;
    },
    options(newOptions) {
      this.rawValue = newOptions.find(o => {
        const v = Array.isArray(o) ? o[0] : o;
        return v === this.rawValue;
      });
    }
  },
  computed: {
    $_VueXeditable_isValueEmpty() {
      return (
        this.rawValue === null ||
        this.rawValue === undefined ||
        this.rawValue === ""
      );
    }
  },
  created() {
    let self = this;
		self.langCode = localStorage.getItem("lang");
  },
  mounted() {
    window.addEventListener("click", this.clickOutSide);
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutSide);
    this.isEditing = null;
    this.rawValue = null;
  },
  methods: {
    clickOutSide(e) {
      if (!this.$refs.editable.contains(e.target) && this.isEditing) {
        this.isEditing = false;
      }
    },
    onChange(e) {
      this.isEditing = false;
      this.$emit("value-did-change", this.rawValue, this.name);
    },
    $_VueXeditable_getHTMLValue() {
      if (this.type == "custom") {
        if (this.customDisplayItem && this.customDisplayProp) {
          return this.$td(this.customDisplayItem, this.customDisplayProp);
        }

        return this.customDisplay;
      }

      if (this.$_VueXeditable_isValueEmpty) {
        return this.empty;
      }

      if (this.type === "select" && Array.isArray(this.rawValue)) {
        return this.rawValue[this.rawValue.length - 1];
      }

      if (this.type === "currency") {
        return new Intl.NumberFormat(this.langCode, { style: 'currency', currency: 'EUR' }).format(this.rawValue);
      }

      if (this.rawValue === undefined || this.rawValue === null) {
        return "?";
      }

      return this.rawValue;
    },
    $_VueXeditable_onKeydown(event) {
      if (!this.isEditing) {
        return;
      }

      if (event.keyCode === 13) {
        this.$_VueXeditable_stopEditing(event);
      } else if (event.keyCode === 27) {
        this.$_VueXeditable_stopEditing(event);
      }
    },
    $_VueXeditable_maybeStartEditing(value, event) {
      if (
        (value === 1 && !this.editOnDoubleClick) ||
        (value === 2 && this.editOnDoubleClick)
      ) {
        this.$_VueXeditable_startEditing(event);
      }
    },
    $_VueXeditable_startEditing(event) {
      this.isEditing = true;
      let that = this;
      that.$emit("start-editing", this.rawValue, this.name);
      setTimeout(function() {
        let inputs = Array.from(event.target.nextElementSibling.children);
        inputs.forEach(i => {
          i.focus();
        });
      }, 100);
    },
    $_VueXeditable_stopEditing(event) {
      this.isEditing = false;
      this.$emit("stop-editing", event.target.value, this.name);
      this.$_VueXeditable_valueDidChange(event.target.value);
    },
    $_VueXeditable_valueDidChange(newValue) {
      if (this.$_VueXeditable_hasValueChanged(newValue)) {
        this.$emit("value-will-change", this.rawValue, this.name);
        this.$_VueXeditable_makeLocalUpdate(newValue);
        this.$emit("input", newValue);
        this.$emit("value-did-change", newValue, this.name);
      }
    },
    $_VueXeditable_hasValueChanged(newValue) {
      return newValue !== this.rawValue;
    },
    $_VueXeditable_makeLocalUpdate(newValue) {
      this.rawValue = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>